import React from "react";
import auth from "../../Auth";
import {
    Scheduler,
    DayView,
    WeekView,
    SchedulerItemProps,
    SchedulerItem,
    SchedulerSlot,
    SchedulerDataChangeEvent,
    SchedulerFormProps,
    SchedulerGroupsContext,
    useSchedulerFieldsContext,
    MonthView,
    TimelineView,
    SchedulerForm,
    SchedulerViewSlot,
    SchedulerViewSlotProps,
} from "@progress/kendo-react-scheduler";
import Collapsible from "react-collapsible";
import BreadCrumbs from "../../Shared/BreadCrumbs/BreadCrumbs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClosedCaptioning, faCross, faFileExcel, faSearch, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { Switch } from "@progress/kendo-react-inputs";
import "../Scheduler/Scheduler.css";
import { extendDataItem, guid } from "@progress/kendo-react-common";
import { convertToUTCFormat, formatDateToICalendarException, getAvaliableAndAllocatedShift, getPositionCount, getPositionCountFilled, getPositionCountUpdated, getReqNumberByPosition, getReqNumberByPositionCount, getResources, getScheduleData, group } from "../Common/Helper";
import Service from "../Service/Service";
import FilterInformation from "./Filter/Filter";
import { addDays, dateFormatter2, downloadExcel, errorToastr, getFormattedDate, localDateTime, successToastr, warningToastr } from "../../../HelperMethods";
import { EXCEL_DOWNLOAD_INPROGRESS, NO_DATA_AVAILABLE_TO_GENERATE_REPORT, NOT_AVAILABLE_SHIFT_CONFIRMATION_MSG, SCHEDULE_SHIFT_SLOT_DELETED_SUCCESS_MSG, SCHEDULE_UNABAILABILTY_DELETED_SUCCESS_MSG, SCHEDULE_UNABAILABILTY_SUCCESS_MSG } from "../../Shared/AppMessages";
import Skeleton from "react-loading-skeleton";
import AssignShift from "../../AssignSchedule/AssignShift";
import { AuthRoleType, isRoleType, schedulerLegendColors, schedulerLegendLabels, SchedulingStatus } from "../../Shared/AppConstants";
import { AppPermissions } from "../../Shared/Constants/AppPermissions";
import { State, toODataString } from "@progress/kendo-data-query";
import { KendoFilter } from "../../ReusableComponents";
import UnAvailability from "../Common/UnAvailability";
import DashboardIcons from "../../DashBoard/DashboardIcons";
import { toolTip } from "../../DashBoard/GlobalActions";
import Legend from "../../Shared/Legend/Legend";

export interface SchedulerProps {
    props: any;
    match: any;
}

interface SchedulingState {
    data: any;
    searchQuery: string;
    clientId?: string;
    toggleFirst: boolean;
    switchValue: boolean;
    editedEvent: any,
    divisionId?: string;
    locationId?: string;
    departmentId?: string;
    scheduleId?: string;
    selectedJobCategory: any;
    selectedPositions: any;
    isAllJobCatSelected: any;
    isAllJobPosSelected: any;
    isIdsLoaded: boolean;
    dataState?: any;
    startDate?: any;
    endDate?: any;
    onCloseModal?: any;
    propsAssign?: any;
    showAssignShift: boolean;
    deptId?: any;
    isVendorRole: boolean;
    isProviderRole: boolean;
}

class Scheduling extends React.Component<SchedulerProps, SchedulingState> {
    clickedDate: Date | null = null;
    constructor(props) {
        super(props);
        const locId = this.props.match.params.locId;
        const deptId = this.props.match.params.deptId;
        const schId = this.props.match.params.schId;
        this.state = {
            clientId: auth.getClient(),
            scheduleId: schId,
            deptId: deptId,
            data: [],
            searchQuery: '',
            switchValue: true,
            toggleFirst: true,
            editedEvent: null,
            selectedJobCategory: [],
            selectedPositions: [],
            isAllJobCatSelected: false,
            isAllJobPosSelected: false,
            isIdsLoaded: false,
            startDate: new Date(),
            endDate: addDays(new Date(), 30),
            showAssignShift: false,
            isVendorRole: isRoleType(AuthRoleType.Vendor),
            isProviderRole: isRoleType(AuthRoleType.Provider),
        };
    }

    componentDidMount() {
        document.body.classList.add("scheduler-shift-wrap");
        const { scheduleId } = this.state;
        if (scheduleId) {
            this.getSchedules(scheduleId);
        }
        if (this.state.isVendorRole || this.state.isProviderRole) {
            this.getSchedules(null);
        }
    }
    componentDidUpdate() {
        document.body.classList.remove("scheduler-shift-wrap");

    }
    componentWillUnmount() {
        document.body.classList.remove("scheduler-shift-wrap");
    }

    getSchedules(schId) {
        if (schId != null && schId != undefined) {
            Service.getSchedules(schId).then((res) => {
                let schData = res.data;
                let queryParams = `scheduleId eq ${schId}`;
                Service.getSchedulesLookup(queryParams).then((res) => {
                    this.setState({
                        divisionId: res.data[0].divisionId,
                        locationId: res.data[0].locationId,
                        departmentId: res.data[0].departmentId,
                        isIdsLoaded: true,
                    });
                });

                if (schData != null && schData.length > 0) {
                    var records = getScheduleData(schData);
                    this.setState({ data: records });
                }
            });
        } else {

            Service.getAllSchedules().then((res) => {
                let schData = res.data;

                if (schData != null && schData.length > 0) {
                    var records = getScheduleData(schData);
                    this.setState({ data: records, isIdsLoaded: true });
                }
            });
        }
    }

    handleGetSchedule = (schId) => {
        this.setState({ isIdsLoaded: false });
        this.getSchedules(schId);
    }

    handleObjChange = (change) => {
        change["isDirty"] = true;
        this.setState(change);
    };

    handleDataChange = ({ created, updated, deleted }) => {
        // this.setState((prevState) => ({
        //     data: prevState.data
        //         .filter((item) => !deleted.some((del) => del.id === item.id))
        //         .map((item) => updated.find((upd) => upd.id === item.id) || item)
        //         .concat(created.map((item) => ({ ...item, id: guid() }))),
        // }));

        if (updated != null && updated.length > 0) {

            if (updated[0].shiftType == SchedulingStatus.ASSIGNED) {
                var recExceptionValue = updated[0].recurrenceExceptions;
                var exValue: any = "";
                if (recExceptionValue)
                    exValue = recExceptionValue.join(",");
                let data = {
                    scheduleId: this.state.scheduleId,
                    assignedId: updated[0].assignedId,
                    recurrenceExceptions: exValue,
                    deleteAll: false,
                    unAssignedDate: this.clickedDate

                };
                Service.deleteAssignedScheduleShift(data).then((res) => {
                    successToastr(SCHEDULE_SHIFT_SLOT_DELETED_SUCCESS_MSG);
                    this.getSchedules(this.state.scheduleId);
                    this.clickedDate = null;
                });
                return;
            }
            if (updated[0].shiftType == SchedulingStatus.GENERATED
                || updated[0].shiftType == SchedulingStatus.PUBLISHED
            ) {
                var recExceptionValue = updated[0].recurrenceExceptions;
                var exValue: any = "";
                if (recExceptionValue)
                    exValue = recExceptionValue.join(",");
                let data = {
                    scheduleId: this.state.scheduleId,
                    generatedId: updated[0].generatedId,
                    startDate: updated[0].start,
                    recurrenceException: exValue,
                };
                Service.patchScheduleShift(data).then((res) => {
                    successToastr(SCHEDULE_SHIFT_SLOT_DELETED_SUCCESS_MSG);
                    this.getSchedules(this.state.scheduleId);
                });
            }
        }

        if (deleted != null && deleted.length > 0) {
            if (deleted[0].shiftType == SchedulingStatus.ASSIGNED) {
                var recExceptionValue = deleted[0].recurrenceExceptions;
                var exValue:any = "";
                if (recExceptionValue)
                    exValue = recExceptionValue.join(",");
                let data = {
                    scheduleId: this.state.scheduleId,
                    assignedId: deleted[0].assignedId,
                    recurrenceExceptions: exValue,
                    deleteAll: true

                };
                Service.deleteAssignedScheduleShift(data).then((res) => {
                    successToastr(SCHEDULE_SHIFT_SLOT_DELETED_SUCCESS_MSG);
                    this.getSchedules(this.state.scheduleId);
                });
                return
            }
            if (deleted[0].shiftType == SchedulingStatus.PUBLISHED) {
                var scheduleId = this.state.scheduleId;
                var publishedId = deleted[0].publishedId;
                Service.deletePublishSchedule(scheduleId, publishedId).then((res) => {
                    successToastr(SCHEDULE_SHIFT_SLOT_DELETED_SUCCESS_MSG);
                    this.getSchedules(this.state.scheduleId);
                });
            } else if (deleted[0].shiftType == SchedulingStatus.GENERATED) {
                var scheduleId = this.state.scheduleId;
                var generatedId = deleted[0].generatedId;
                Service.deleteGenerateSchedule(scheduleId, generatedId).then((res) => {
                    successToastr(SCHEDULE_SHIFT_SLOT_DELETED_SUCCESS_MSG);
                    this.getSchedules(this.state.scheduleId);
                });
            }
            else if (deleted[0].shiftType == SchedulingStatus.UNAVAILABILITY) {
                var scheduleId = this.state.scheduleId;
                var availabilityId = deleted[0].availability_id;
                Service.deleteGenerateUnAvailablity(scheduleId, availabilityId).then((res) => {
                    successToastr(SCHEDULE_UNABAILABILTY_DELETED_SUCCESS_MSG);
                    this.getSchedules(this.state.scheduleId);
                });
            }
        }
    };

    handleChange = (e, field) => {
        var stateObj = {};

        stateObj[field] = e.value;
        this.setState(stateObj);

    };

    handleSearchChange = (event) => {
        this.setState({ searchQuery: event.target.value });
    };

    getFilteredData = () => {
        const { searchQuery, data } = this.state;
        if (data.length > 0) {
            let searchData = searchQuery ? data.filter((item) => item.title.toLowerCase().includes(searchQuery.toLowerCase())) : data;
            if (!this.state.switchValue) {
                searchData = searchData.filter((item) => item.shiftType !== "ASSIGNED")
            }
            return searchData;
        }
        return [];
    };

    handleEdit = (dataItem) => {
        this.setState({ editedEvent: dataItem });
    };

    handleSave = (updatedEvent) => {
        this.handleDataChange({ updated: [updatedEvent], created: [], deleted: [] });
        this.setState({ editedEvent: null });
    };

    handleCancel = () => {
        this.setState({ editedEvent: null });
    };

    CustomSchedulerForm = (props) => {
        if ((props.dataItem.id == null || props.dataItem.id == undefined) && props.dataItem.assignedId == null) {
            return (<UnAvailability
                message={NOT_AVAILABLE_SHIFT_CONFIRMATION_MSG()}
                handleYes={() => this.ScheduleUnAvailablity(props.dataItem.shiftId, props.dataItem.start, props)}
                handleNo={props.onCancel}
            />);
        } else {
            return null;
        }
    };

    ScheduleUnAvailablity = (shiftId, start, props) => {
        props.onClose();

        var shiftGeneratedIdId = this.state.data.filter((x) => x.shiftId == shiftId)[0].generatedId;
        if (shiftGeneratedIdId == undefined || shiftGeneratedIdId == null || shiftGeneratedIdId == "") {
            errorToastr("Shift not found.");
            return false;
        }

        let data = {
            scheduleId: this.state.scheduleId,
            scheduleGeneratedShiftId: shiftGeneratedIdId,
            startDate: start ? localDateTime(start) : null,
            endDate: start ? localDateTime(start) : null,
        };

        Service.postScheduleUnAvailablity(data).then((res) => {
            successToastr(SCHEDULE_UNABAILABILTY_SUCCESS_MSG);
            this.getSchedules(this.state.scheduleId);
        });
    }

    hoverSchedulerSlotItem = (props: SchedulerItemProps) => (
        <SchedulerItem {...props}
            className={`scheduler-item ${props.dataItem.shiftType == SchedulingStatus.GENERATED ? "disabled" : ""}`}
            style={{
                ...props.style,
                backgroundColor: props.dataItem.shiftType == SchedulingStatus.UNAVAILABILITY ? "#f9ecec" : props.dataItem.color, // Default color if none provided
                color: props.dataItem.shiftType == SchedulingStatus.UNAVAILABILITY ? "#ef6565" : props.style.color, // Default color if none provided
                minHeight: props.dataItem.shiftType == SchedulingStatus.ASSIGNED ? "70px" : props.dataItem.minHeight,
            }}
            onRemoveClick={(event) => {

                props.onRemoveClick(event);
                document.body.classList.add("scheduler-shift-wrap");
            }

            }
            onClick={(event) => {
                props.onClick(event);
                this.clickedDate = event.target.props.start
                document.body.classList.add("scheduler-shift-wrap");
            }}
            onDoubleClick={(event) => {
                if (props.onDoubleClick) {
                    event.syntheticEvent.preventDefault();
                    event.syntheticEvent.stopPropagation();
                    if (props.dataItem.id && props.dataItem.publishedId && !this.state.isVendorRole && !this.state.isProviderRole) {
                        this.setState({ propsAssign: event.target.props, showAssignShift: true });
                    }
                }
            }}

        >
            {toolTip(<div className="tooltip-container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'relative' }}
                title={props.dataItem.shiftType != SchedulingStatus.UNAVAILABILITY && props.dataItem.shiftType != SchedulingStatus.ASSIGNED ? getAvaliableAndAllocatedShift(props) : (props.dataItem.shiftType != SchedulingStatus.ASSIGNED ? SchedulingStatus.UNAVAILABILITY : props.dataItem.title)}>

                {props.dataItem.shiftType != SchedulingStatus.UNAVAILABILITY && (
                    <>
                        <span>{props.dataItem.title}</span>
                        <span className="gen-type">{props.dataItem.shiftGenType}</span>
                        {((props.dataItem.shiftType == SchedulingStatus.PUBLISHED) || (props.dataItem.shiftType == SchedulingStatus.GENERATED && props.dataItem.shiftGenType != "REQ"))
                            && (<span>{`${getPositionCountUpdated(props.dataItem.start, props.dataItem.Reqs, props.dataItem.noOfPosData, props.dataItem.no_of_pos)}`}</span>)}
                        {props.dataItem.shiftType == SchedulingStatus.GENERATED && props.dataItem.shiftGenType == "REQ" && (<span>{`${getReqNumberByPositionCount(props.dataItem.start, props.dataItem.Reqs)}`}</span>)}
                    </>
                )}

                {props.dataItem.shiftType == SchedulingStatus.UNAVAILABILITY && (
                    <>
                        <span className="unavailabilty-icon"><FontAwesomeIcon icon={faTimesCircle} className={"mr-2"} /></span>
                    </>
                )}
            </div>)}
        </SchedulerItem>
    );

    CreateQueryString = (dataState) => {
        var queryStr = `${toODataString(dataState, { utcDates: true })}`;
        var finalQueryString = queryStr;
        var queryParams = '';
        if (this.state.clientId != undefined && this.state.clientId != "") queryParams = `clientId eq ${this.state.clientId}`;

        finalQueryString = KendoFilter(
            dataState,
            queryStr,
            queryParams
        );
    }

    CustomViewSlot = (props: SchedulerViewSlotProps) => {
        return (
            <SchedulerViewSlot
                {...props}
                style={{
                    ...props.style,
                    //cursor: !props.isWorkDay || !props.isWorkHour ? 'no-drop' : undefined
                }}
            />
        );
    };

    onCloseClick = () => {
        this.setState({ showAssignShift: false });
    }

    render() {
        const {
            divisionId,
            locationId,
            departmentId,
            scheduleId,
            deptId,
            selectedJobCategory,
            selectedPositions,
            isAllJobCatSelected,
            isAllJobPosSelected,
            isIdsLoaded,
            showAssignShift
        } = this.state;
        const commonInfo = {
            divisionId,
            locationId,
            departmentId,
            scheduleId,
            selectedJobCategory,
            selectedPositions,
            isAllJobCatSelected,
            isAllJobPosSelected,
        };

        return (
            <div className="col-11 mx-auto pl-0 pr-0 mt-3 scheduler-wrapper" id="scheduler-wrapper">
                <div className="row pt-2 pb-2 accordianTitleClr mx-auto mb-3 mt-3">
                    <div className="col-10 fonFifteen">
                        <BreadCrumbs globalData={{
                            clientId: this.state.clientId,
                            locationId: this.state.locationId,
                            departmentId: this.state.departmentId,
                            deptId: this.state.departmentId,
                            scheduleId: this.state.scheduleId,
                        }} />
                    </div>
                </div>
                {auth.hasPermissionV2(AppPermissions.VIEW_SCHEDULE_FILTER) && (
                    <Collapsible trigger={<span>Schedule Filter</span>} open={this.state.toggleFirst}>
                        {<FilterInformation
                            scheduleId={scheduleId}
                            deptId={deptId}
                            isIdsLoaded={this.state.scheduleId && this.state.deptId ? isIdsLoaded : true}
                            data={commonInfo}
                            dropdownDisable={this.state.scheduleId && this.state.deptId ? true : false}
                            handleObjChange={this.handleObjChange}
                            handleGetSchedule={this.handleGetSchedule}
                        />}
                    </Collapsible>
                )}
                <div className="row mt-2 mb-2 justify-content-center">
                    <div className="col-12 d-flex align-items-center justify-content-between">
                        <div
                            className="input-group col-4 pl-0 pr-sm-0 forSearchPopup">
                            <input
                                type="search"
                                className="AdvacneBorderSearch AdvacneBorderSearch_new  AdvacneBorderSearch_borderright form-control placeholder-mobile searchText"
                                placeholder="Search text here!"
                                title={'Search Shifts'}
                                onChange={this.handleSearchChange}
                                value={this.state.searchQuery}
                            />
                            <div className="input-group-append">
                                <button
                                    className="btn-secondary Advancesearch-icon border-left-0 search-button-focus basicsearch-mobile"
                                    type="button"
                                >
                                    <FontAwesomeIcon icon={faSearch} className={"mr-2"} />
                                </button>
                            </div>
                        </div>

                        <Legend colors={schedulerLegendColors} labels={schedulerLegendLabels} />

                        <div className=" d-flex">
                            {(!this.state.isVendorRole && !this.state.isProviderRole)
                                && (
                                    <div className="px-3">
                                        <label className="mb-0 mr-2 font-weight-bold"> View Allocated Shifts
                                        </label>
                                        <Switch
                                            onLabel={""}
                                            offLabel={""}
                                            checked={this.state.switchValue}
                                            onChange={(e) => this.handleChange(e, "switchValue")}
                                        />
                                    </div>
                                )
                            }
                            {auth.hasPermissionV2(AppPermissions.SCHEDULE_EXCEL_EXPORT) && (
                                <span title="Export to Excel" onClick={() => this.downloadScheduleExcel()} className="mr-2 cursor-pointer">
                                    <img src={DashboardIcons.excelLogo} width={30} height={30} alt="Excel Icon" />
                                </span>
                            )}
                        </div>
                    </div>
                </div>
                {!isIdsLoaded &&
                    Array.from({ length: 5 }).map((item, i) => (
                        <div className="row mx-auto mt-2" key={i}>
                            {Array.from({ length: 1 }).map((item, j) => (
                                <div className="col-12 col-sm-12 col-lg-12 mt-sm-0  mt-1" key={j}>
                                    <Skeleton width={100} />
                                    <Skeleton height={30} />
                                </div>
                            ))}
                        </div>
                    ))}
                {isIdsLoaded && (
                    <Scheduler
                        group={group}
                        resources={getResources(this.state.data, this.state.switchValue)}
                        data={this.getFilteredData()}
                        defaultDate={new Date()}
                        editable={{ add: true, remove: true, drag: true, resize: true, select: true, edit: true }}
                        onDataChange={this.handleDataChange}
                        form={this.CustomSchedulerForm}
                        item={this.hoverSchedulerSlotItem}
                        viewSlot={this.CustomViewSlot}
                    >
                        <WeekView
                            slotDivisions={2}
                            step={60}
                            name="Shift Scheduling Week" numberOfDays={7}
                            slotDuration={1440}
                        />
                        <MonthView title="Month" selectedDateFormat="{0:M}" selectedShortDateFormat="{0:M}" />

                    </Scheduler>)}

                {showAssignShift && (
                    <AssignShift
                        props={this.state.propsAssign.dataItem}
                        onCloseModal={this.onCloseClick}
                        scheduleId={this.state.scheduleId}
                        handleGetSchedule={this.handleGetSchedule}
                    />
                )}
            </div>
        );
    }

    downloadScheduleExcel(): void {
        var finalState: State = {
            ...this.state.dataState,
            take: null,
            skip: 0,
        };

        let finalQueryString = this.CreateQueryString(finalState);
        successToastr(EXCEL_DOWNLOAD_INPROGRESS);

        const data = {
            locationId: this.state.locationId,
            divisionId: this.state.divisionId,
            departmentId: this.state.departmentId,
            scheduleId: this.state.scheduleId,
            positions: this.state.selectedPositions.filter((x) => x.id != 9999).map((m) => m.id),
            startDate: this.state.startDate ? localDateTime(this.state.startDate) : null,
            endDate: this.state.endDate ? localDateTime(this.state.endDate) : null,
            SearchQuery: this.state.searchQuery,
            Toggle: this.state.switchValue,

        };
        Service.getShiftSchedule(finalQueryString, data).then((res: any) => {
            if (res) {
                if (res.data === null) {
                    errorToastr(NO_DATA_AVAILABLE_TO_GENERATE_REPORT);
                    return;
                }
                downloadExcel("Shift Schedule.xlsx", res.data);
            }
        });
    }
}

export default Scheduling;